import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'

export const XlsFieldType = Object.freeze({ 'DATE': 0 })

export function parseXlsTable ({results, props, custprops, header}, firstRow, objectKeys, objectValueConverters = {}) {
  // const FIRST_ROW = 16 - 1
  let tableDataStartRow = firstRow
  if (custprops != null) {
    try {
      if (custprops.hasOwnProperty('PassengersStartRow')) {
        tableDataStartRow = parseInt(custprops['PassengersStartRow']) - 1
      }
      if (custprops.hasOwnProperty('StartRow')) {
        tableDataStartRow = parseInt(custprops['StartRow']) - 1
      }
    } catch (e) {
      // skip error on read properties;
    }
  }
  let items = []
  let i = tableDataStartRow
  let isNotEnd = true

  const itemTemplate = {}
  for (let i in objectKeys) {
    let h = objectKeys[i]
    itemTemplate[h] = null
  }

  while (isNotEnd) {
    const row = results[i]
    if (!row || Object.keys(row).length === 0) {
      isNotEnd = true
      break
    }
    let item = Object.assign(cloneDeep(itemTemplate), row)
    Object.keys(objectValueConverters).forEach((key) => {
      if (item[key]) {
        if (typeof objectValueConverters[key] === 'function') {
          item[key] = objectValueConverters[key].call(null, item[key])
        }
      }
    })

    items.push(item)
    i++
    // prevent unbreaked loop
    if (i > 100000) {
      console.error('i>100000')
      break
    }
  }

  return items
}

/**
 *
 * @param serial
 * @returns {string|null} iso8601 date
 */
export function convertExcelSerialDate (serial) {
  if (serial == null) {
    return null
  }
  let utcDays = Math.floor(serial - 25569)
  let utcValue = utcDays * 86400
  let dateInfo = new Date(utcValue * 1000)

  let fractionalDay = serial - Math.floor(serial) + 0.0000001

  let totalSeconds = Math.floor(86400 * fractionalDay)

  return moment.utc(utcValue * 1000).add(totalSeconds, 'seconds').toISOString()
}

export function convertToString (value) {
  return '' + value
}



// WEBPACK FOOTER //
// ./src/utils/excel.js